function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import styles from "../../@patternfly/patternfly/components/OptionsMenu/options-menu.css.js";
import { css, getModifier } from '@patternfly/react-styles';
import { OptionsMenuDirection, OptionsMenuPosition } from './optionsMenuConstants';
var propTypes = {
  /** Classes applied to root element of the Options menu */
  className: PropTypes.string,

  /** Id of the root element of the Options menu */
  id: PropTypes.string.isRequired,

  /** Array of OptionsMenuItem and/or OptionMenuItemGroup nodes that will be rendered in the Options menu list */
  menuItems: PropTypes.arrayOf(PropTypes.node).isRequired,

  /** Either an OptionsMenuToggle or an OptionsMenuToggleWithText to use to toggle the Options menu */
  toggle: PropTypes.node.isRequired,

  /** Flag to indicate if menu is open */
  isOpen: PropTypes.bool,

  /** Flag to indicate the toggle has no border or background */
  isPlain: PropTypes.bool,

  /** Provides an accessible name for the Options menu */
  ariaLabelMenu: PropTypes.string,

  /** Display menu above or below Options menu toggle */
  direction: PropTypes.oneOf(Object.values(OptionsMenuDirection)),

  /** Indicates where menu will be aligned horizontally */
  position: PropTypes.oneOf(Object.values(OptionsMenuPosition))
};
var defaultProps = {
  className: '',
  isOpen: false,
  isPlain: false,
  ariaLabelMenu: '',
  direction: OptionsMenuDirection.down,
  position: OptionsMenuPosition.left
};

var OptionsMenu = function OptionsMenu(_ref) {
  var className = _ref.className,
      direction = _ref.direction,
      position = _ref.position,
      id = _ref.id,
      isOpen = _ref.isOpen,
      isPlain = _ref.isPlain,
      ariaLabelMenu = _ref.ariaLabelMenu,
      menuItems = _ref.menuItems,
      toggle = _ref.toggle;
  return React.createElement("div", {
    id: id,
    className: css(styles.optionsMenu, direction === OptionsMenuDirection.up && getModifier(styles, 'top'), position === OptionsMenuPosition.right && getModifier(styles, 'align-right'), isOpen && getModifier(styles, 'expanded'), className)
  }, Children.map(toggle, function (oneToggle) {
    return cloneElement(oneToggle, {
      parentId: id,
      isOpen: isOpen,
      isPlain: isPlain
    });
  }), isOpen && React.createElement("ul", _extends({
    className: css(styles.optionsMenuMenu, position === OptionsMenuPosition.right && getModifier(styles, 'align-right'))
  }, ariaLabelMenu ? {
    'aria-label': ariaLabelMenu
  } : {
    'aria-labelledby': "".concat(id, "-toggle")
  }), menuItems.map(function (item) {
    return item;
  })));
};

OptionsMenu.propTypes = propTypes;
OptionsMenu.defaultProps = defaultProps;
export default OptionsMenu;